export default __webpack_public_path__ + "static/media/map_extended.56b5423c.png";